// Test tools → the test clock: the mock API's "now" (IST) and buttons that move it on, so a campaign runs hour by
// hour. The real backend runs on the real clock.
import { DemoClock } from '@/components/DemoClock'
import { useClock } from '@/features/settings'
import { useAdvanceClock, useNextDayTen } from '../useDemoControls'

export function TestClock() {
  const clock = useClock()
  const advance = useAdvanceClock()
  const nextDay = useNextDayTen()
  if (!clock.data) return null
  return (
    <DemoClock
      clock={clock.data}
      busy={advance.isPending || nextDay.isPending}
      onAdvance={(hours) => advance.mutate(hours)}
      onNextDayTen={() => nextDay.mutate(undefined)}
    />
  )
}
